<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SalesDetailCompanyProfile from './SalesDetailCompanyProfile.vue';
import SalesDetailPartyAddress from './SalesDetailPartyAddress.vue';
import SalesDetailPartyAttorney from './SalesDetailPartyAttorney.vue';
import SalesDetailPartyDocuments from './SalesDetailPartyDocuments.vue';
import SalesDetailPersonProfile from './SalesDetailPersonProfile.vue';
import SalesDetailRepresentative from './SalesDetailRepresentative.vue';

const props = defineProps({
  parties: { type: Array, default: () => [] },
  role: { type: String, required: true },
  transactionId: { type: [Number, String], required: true },
});

const { t } = useI18n();
const filteredParties = computed(() =>
  props.parties.filter(party => party.party_role === props.role)
);
</script>

<template>
  <div class="grid gap-4">
    <div
      v-if="!filteredParties.length"
      class="rounded-lais border border-dashed border-lais-border bg-white p-8 text-center text-sm text-lais-text-muted"
    >
      {{ t('SALES.DETAIL.NO_PARTIES') }}
    </div>
    <section
      v-for="party in filteredParties"
      :key="party.id"
      class="grid gap-4"
      :aria-label="party.display_name"
    >
      <p class="text-base font-semibold text-lais-text">
        {{ party.display_name }}
      </p>
      <SalesDetailCompanyProfile
        v-if="party.party_kind === 'pessoa_juridica'"
        :party="party"
      />
      <SalesDetailPersonProfile v-else :party="party" />
      <SalesDetailPartyAddress
        v-if="party.relation_type === 'principal'"
        :party="party"
      />
      <SalesDetailPartyAttorney
        v-if="
          party.party_kind === 'pessoa_fisica' &&
          party.party_role === 'vendedor' &&
          party.relation_type === 'principal'
        "
        :party="party"
      />
      <SalesDetailPartyDocuments
        :documents="party.documents || []"
        :party-id="party.id"
        :transaction-id="transactionId"
      />
      <div v-if="party.representatives?.length" class="grid gap-3">
        <p class="text-sm font-semibold text-lais-text">
          {{ t('SALES.DETAIL.REPRESENTATIVES') }}
        </p>
        <SalesDetailRepresentative
          v-for="representative in party.representatives"
          :key="representative.id"
          :representative="representative"
          :transaction-id="transactionId"
        />
      </div>
    </section>
  </div>
</template>
